import { addStyle } from "./misc"
import { callOnceOnly } from "./../fs/util"

const css = `
  .VideoPlayer {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }

  .VideoPlayer video {
    width: 100%;
  }

  .VideoPlayer .mainButton {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: rgb(48, 48, 48);
  }

  .VideoPlayer .mainButton,
  .VideoPlayer .smallButton {
    
    position: absolute;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
  }

  .VideoPlayer .smallButton {
    background-color: transparent;
  }

  .VideoPlayer .smallButton>* {
    border-radius: 50%;
    background-color: rgb(48, 48, 48);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /* For testing */
  /*.VideoPlayer .smallButton.smallButtonUnMute>* {
    background-color: red;
  }
  .VideoPlayer .smallButton.smallButtonMute>* {
    background-color: blue;
  }*/

  .VideoPlayer .mainButton {
    width: 48px;
    height: 48px;
    pointer-events: none;
    opacity: 0;
  }

  .VideoPlayer.paused .mainButtonPlay {
    opacity: 0.6;
  }

  .VideoPlayer .mainButtonPause, 
  .VideoPlayer .smallButtonMute
  {
    transition: opacity 0.1s ease-in-out;
  }


  .VideoPlayer.notTouchDevice.playing:hover .mainButtonPause,
  .VideoPlayer.touchDevice.playing.touchStart .mainButtonPause
  {
    opacity: 0.6;
  }

  /* These styles are for the mute and unmute buttons */

  .VideoPlayer .smallButton {
    width: 48px;
    height: 48px;
    top: 0px;
    right: 0px;
    opacity: 0;
    pointer-events: none;
  }
  .VideoPlayer .smallButton>* {
    width: 32px;
    height: 32px;
  }

  /* Show the mute button if its unmuted and paused 
   * or the video player is playing and being hovered over
   */
  .VideoPlayer.notTouchDevice.paused:hover .smallButtonMute, 
  .VideoPlayer.notTouchDevice.playing:hover .smallButtonMute,
  .VideoPlayer.touchDevice.paused.touchStart .smallButtonMute, 
  .VideoPlayer.touchDevice.playing.touchStart .smallButtonMute,
  .VideoPlayer.touchDevice.playing .smallButtonMute.showMuteButton
  {
    opacity: 0.8;
    display: flex;
    transition: opacity 0.1s ease-in-out;
    pointer-events: all;
  }
  /* Because we don't have an unmuted flag then hide the mute button
     if it is muted 
   */
  .VideoPlayer.notTouchDevice.paused.muted:hover .smallButtonMute, 
  .VideoPlayer.paused.muted .smallButtonMute,
  .VideoPlayer.notTouchDevice.playing.muted:hover .smallButtonMute,
  .VideoPlayer.touchDevice.playing.muted.touchStart .smallButtonMute,
  .VideoPlayer.touchDevice.paused.muted.touchStart .smallButtonMute  
  {
    opacity: 0;
    /*display: none;*/
    pointer-events: none;
    transition: opacity 0.1s ease-in-out;
  }

  /* Show the unmute button if it's muted and paused 
   * or playing and muted
   */
  .VideoPlayer.paused.muted .smallButtonUnMute, 
  .VideoPlayer.playing.muted .smallButtonUnMute
  {
    opacity: 0.8;
    display: flex;
    pointer-events: all;
  }

  .VideoPlayer .progressContainer {
    padding-left: 16px;
    padding-right: 16px;
    box-sizing: border-box;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.1s ease-in-out;
    background: linear-gradient(180deg, rgba(48, 48, 48, 0.0001) 1.22%, rgba(48, 48, 48, 0.85) 100%);
    display: none;
  }

  .VideoPlayer .progressHitbox {
    pointer-events: all;
    height: 40px;
    display: flex;
    align-items: center;
    flex-directio: column;
  }

  progress {
    border-radius: 4px; 
    width: 100%;
    height: 8px;
    overflow: hidden;
    /*background-color: #666666;*/
    background-color: rgba(255, 255, 255, 0.4);
    border: 0;
  }

  progress::-webkit-progress-bar {
    /*background-color: #666666;*/
    background-color: rgba(255, 255, 255, 0.4);
  }

  progress::-webkit-progress-value {
    background-color: white;
    
  }


  progress::-moz-progress-bar {
    background-color: white;
    
  }



  .VideoPlayer.notTouchDevice.paused:hover .progressContainer,
  .VideoPlayer.notTouchDevice.playing:hover .progressContainer,
  .VideoPlayer.touchDevice.paused.touchStart .progressContainer,
  .VideoPlayer.touchDevice.playing.touchStart .progressContainer {
    opacity: 1;
    display: block;
  }
`

const loadCSS = callOnceOnly(function () {
  addStyle(css)
})

export default loadCSS
